export const iconFontAwesomeSocialCamera = (
	<i className="fa-solid fa-camera"></i>
);
